// src/pages/AboutPage.jsx

import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import React from "react";

const AboutPage = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
    });
  }, []);

  return (
    <div className="pt-20">

      {/* Section 1: Who We Are */}
      <section className="bg-white py-16">
        <div className="max-w-4xl mx-auto text-center px-4 space-y-4" data-aos="fade-up">
          <h2 className="text-3xl font-bold text-gray-800">Who We Are</h2>
          <p className="text-gray-700 text-lg">
            Aarsh Industries is a trusted name in the PTMT manufacturing industry, committed to combining modern
            technology with time-tested values. We believe in doing things the right way—from choosing virgin raw
            materials to inspecting every single unit with precision hydro testing. Our team thrives on innovation and
            consistency, ensuring that every customer gets products that last long and shine brighter.
          </p>
        </div>
      </section>

      {/* Section 2: Our Infrastructure */}
      <section className="bg-gray-50 py-16">
        <div className="max-w-4xl mx-auto text-center px-4 space-y-4" data-aos="fade-up" data-aos-delay="100">
          <h2 className="text-3xl font-bold text-gray-800">Our Infrastructure</h2>
          <p className="text-gray-700 text-lg">
            Operating on a 10,100 square yard plot with a 20,000 square feet factory, Aarsh Industries leverages
            cutting-edge machinery to ensure consistent quality. Our factory is designed for efficiency, safety,
            and scalability, allowing us to meet diverse production demands without compromise.
          </p>
        </div>
      </section>

      {/* Section 3: Mission & Vision */}
      <section className="py-16 bg-white" data-aos="fade-up" data-aos-duration="800" data-aos-easing="ease-in-out">
        <div className="max-w-6xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Mission Box */}
            <div className="flex flex-col items-center text-center bg-blue-50 p-6 rounded-2xl shadow-md hover:shadow-lg transition-shadow duration-300">
              <img src="mission.svg" alt="Mission" className="w-20 h-20 mb-4 object-cover" />
              <h3 className="text-xl font-semibold text-blue-900 mb-2">Mission</h3>
              <p className="text-gray-700">
                To deliver superior quality PTMT products using certified virgin material, precise testing, and modern
                designs — ensuring durability, shine, and affordability for every household.
              </p>
            </div>

            {/* Vision Box */}
            <div className="flex flex-col items-center text-center bg-blue-50 p-6 rounded-2xl shadow-md hover:shadow-lg transition-shadow duration-300">
              <img src="vision.svg" alt="Vision" className="w-20 h-20 mb-4 object-cover" />
              <h3 className="text-xl font-semibold text-blue-900 mb-2">Vision</h3>
              <p className="text-gray-700">
                To be a leading name in bathroomware by blending innovation, quality, and ethical practices — creating
                long-lasting trust with every product we offer.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section 4: Leadership at Aarsh */}
      <section className="bg-gray-50 py-16">
        <div className="max-w-4xl mx-auto text-center px-4 space-y-4" data-aos="fade-up" data-aos-delay="200">
          <h2 className="text-3xl font-bold text-gray-800">Leadership at Aarsh</h2>
          <p className="text-gray-700 text-lg">
            Stepping into the vibrant world of PTMT manufacturing, Karan brings a fresh perspective and a wealth of
            diverse expertise. As the owner of Aarsh Industries, he embodies a unique blend of technology and
            creativity. With a background in IT and a specialization in data analytics, he approaches every challenge
            with a logical and analytical mindset. His journey through the world of robotics—building machines from
            scratch—has given him deep insight into innovation and problem-solving, making him a forward-thinking
            leader in the industry.
          </p>
        </div>
      </section>

<section className="bg-gray-100 py-16 px-4 text-center" data-aos="fade-up">
  <div className="max-w-4xl mx-auto">
    <h2 className="text-3xl font-bold text-gray-800 mb-6">Inside Our Factory</h2>
    <div className="aspect-w-16 aspect-h-9 max-w-3xl mx-auto">
      <iframe
        className="w-full h-64 md:h-[500px]"
        src="https://www.youtube.com/embed/26LmDsxPg7o?si=anLm9a6QZEPi7eit"
        title="Factory Tour"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  </div>
</section>


    </div>
  );
};

export default AboutPage;
